/**
 * General wrapper to cache API validation calls.
 */
export const cacheAsyncResponse = (asyncValidate) => {
  let _valid = false;
  let _args = '';

  return async (...args) => {
    if (args.toString() !== _args) {
      const response = await asyncValidate(...args);
      _args = args.toString();
      _valid = response;

      return response;
    }

    return _valid;
  };
};

/**
 * Validate Public Key and charges object for PDP display
**/

export const isValidPublicKey = (key) => {
  var keyFormat = /[a-zA-Z0-9_]\_[a-zA-Z0-9_]{32}$/;
  if (key.match(keyFormat)) {
    return true;
  }
  return false
};

export const isValidCharges = (arr) => {
  for (let i = 0; i < arr.length; i++) {
    if (isNaN(arr[i]) === true) {
      return false;
    }
  }
  return true
}